import * as React from 'react';
import {useEffect} from 'react';
import {useAccountStore} from "@/store/useAccountStore";
import {accountTypeNames, AccountTypes} from "@/constatants";
import {FtSelect} from "@/component/input/FtSelect";

interface Props {
    initialType?: string;
    value: number | undefined;
    onChange: (value: number | undefined) => void;
}

export function AccountInput(props: Props) {
    const allAccounts = useAccountStore(state => state.accounts);
    const [type, setType] = React.useState(props.initialType ?? AccountTypes[0]);
    const filteredAccounts = allAccounts.filter(account => account.type === type && (account.id === props.value || !account.archived));

    useEffect(() => {
        if (!props.value) return;
        const account = allAccounts.find(account => account.id === props.value);
        if (account) setType(account.type);
    }, [props.value]);

    useEffect(() => {
        if (props.initialType && props.initialType !== type) {
            setType(props.initialType);
            props.onChange(undefined);
        }
    }, [props.initialType]);

    return <div style={{display: "flex", gap: 4}}>
        <FtSelect
            value={type}
            values={AccountTypes}
            labels={AccountTypes.map(t => accountTypeNames[t])}
            onChange={(type) => {
                setType(type);
                props.onChange(undefined);
            }}/>

        <FtSelect
            value={props.value?.toString() ?? ''}
            values={filteredAccounts.map(account => account.id.toString())}
            labels={filteredAccounts.map(account => account.name)}
            emptyLabel="계정을 선택하세요"
            onChange={(value) => {
                const id = value ? parseInt(value) : undefined;
                if (id === undefined || !isNaN(id)) {
                    props.onChange(id);
                }
            }}/>
    </div>;
}